import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState,useEffect } from "react";
import {getPhysicalCountList2,
  retrievePhysicalCountListOnly,getPhyOpnBalScan,
  replforceclose,retrieveReplenishmentListOnly,getReplenishmentNoList,
  replconsolidate,getadjustmentreasoncode,retrieveReplenishmentList,updaterepllist} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import BasicTabs from "ui-components/tabs/BasicTabs";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import { FormTitle } from "ui-components/Form";
import { Grid } from "@mui/material";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import { uploadPC } from "services/data.inventory.service";
import { Success, Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { EditableNumber } from "ui-components/EditableInput2";

function UpdateReplenishment({zoneLocationAisle}) {
  const {permissions, allowAll} = useTeamValue();
const editPermission =
  allowAll ||
  (Boolean(permissions["Replenishment"]) &&
    permissions["Replenishment"].findIndex((b) => b === "edit") !== -1);
    const { customerCode } = useCustomerValue();
    console.log(customerCode);
    const { pCountNo } = useState("");
    const [alert, setAlert] = useState(null);
    const [status, setStatus] = useState("");
    const [replnos, setReplNOs] = useState([]);
    const [selectedReplNO, setSelectedReplNO] = useState("");
    const [pnos, setPNOs] = useState([]);
    const [selectedPNO, setSelectedPNO] = useState("");
    //const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
    const onError = (error, setAlert) => {
      setAlert(null); // Clear any existing alert
      setAlert(<Error_ data={error} onChange={setAlert} />);
    };
    const onSuccess = (data, setAlert) => {
      setAlert(null); // Clear any existing alert
      setAlert(<Success data={data} onChange={setAlert} />);
    };
    const tabs = ["Consolidate"];
    //const uploadPCMutation = useMutation(uploadPC, {});
    const uploadPCMutation = useMutation(uploadPC, {
      onSuccess: (data) => {
        document.getElementById("files").value = null;
        setUploadResps(data.data.data);
        onSuccess(data, setAlert);
      },
      onError: (error) => onError(error, setAlert),
    });
    const uploadStatus = uploadPCMutation.status === "loading";
    const [uploadResps, setUploadResps] = useState([]);
    const { isFetchingPNo, refetch:refetchPNo } = useQuery({
      queryKey: [ "PNOOption", { customerCode } ],
      queryFn: () =>
        getReplenishmentNoList(customerCode),
      enabled: true,
      onSuccess: (data) => {
        if (data && data.data) {
          setReplNOs(data.data.data);
        }
      },
      //onError,
      onError: (error) => onError(error, setAlert),
    });
    
    const getphysicalcountMutation = useMutation((requestdata) => getPhysicalCountList2(requestdata), {
      onSuccess: (data) => {
        const { pCountNo } = data.data;
        console.log("PCountNo:", pCountNo);
        retrievePhysicalCountListOnly(pCountNo).then((response)=> {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${pCountNo}.xlsx`);
        document.body.appendChild(link);
        link.click();
        });
        // queryClient.invalidateQueries(["exception-list"]);
        // setAlert(<Success data={data} onChange={setAlert} />);
      },
      //onError,
      onError: (error) => onError(error, setAlert),
    });

    const handleDownload = () => {
      console.log(selectedReplNO); // Log the selected value
      // Add code here to handle the download
      retrieveReplenishmentListOnly(selectedReplNO).then((response) => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${selectedReplNO}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    };
    
    const handleSubmit = (values, actions) => {
      setAlert(null);
      let formData = new FormData();
      formData.append("files", values.files[0], values.files[0].name);
      formData.append("customerCode", customerCode);
      formData.append("PCountNo", selectedPNO);
      formData.append("vendorCode", values.vendorCode);
      uploadPCMutation.mutate(formData, {
        onSuccess: (data) => {
          console.log("Success response:", data); // Log success response
          document.getElementById("files").value = null;
          //  document.getElementById("files").value = null;
          //  actions.setFieldValue("vendorCode", "");
          //  actions.resetForm();
          setUploadResps(data.data.data);
          setAlert(<Success content="File is uploaded successfully." onChange={setAlert} />);
        },
        //onError,
        onError: (error) => {
          console.error("Error response:", error);
          const errorMessage = error.response?.data?.message || "An unexpected error occurred";
          onError(error, setAlert);
          setAlert(<Error_ content={errorMessage} onChange={setAlert} />);
        },
      });
      actions.setSubmitting(false);
      // actions.resetForm(true);
    };

    useEffect(() => {
      refetchPNo(); // Trigger the query to fetch data
    }, []);

    const render = () => {
        let task;
        switch (status) {
          case "Physical Count List":
            console.log("pnos value:", selectedPNO);
            console.log("customerCode value:", customerCode);
            task = (
              <PCountList
                 //columns={columns}
                 customerCode={customerCode}
                 pnos={selectedPNO}
              />
            );
            break;
    
          case "Count Summary Lookup":
            task = <PCountSummaryLookUp customerCode={customerCode} pnos={selectedPNO} onError={onError} editPermission={editPermission}/>;
            break;
          case "Latest Count Data":
            task = <CountData customerCode={customerCode} pnos={selectedPNO} onError={onError} editPermission={editPermission}/>;
            break;
          case "Consolidate":
            task = <Consolidate customerCode={customerCode} replnos={selectedReplNO} onError={onError} editPermission={editPermission}/>;
            break;
          case "Allocation Queue":
            task = <AllocationQueue customerCode={customerCode} />;
            break;
            case "Demo":
            task = <Demo2 customerCode={customerCode} />;
            break;
        }
    
        return task;
      };

    return (
        <InboundLayout lg={12}>
           {alert}
            <InboundHeaderCard>
                <FormTitle title={"Update Replenishment"} />
                <Fieldset label="Please choose a replenishment to proceed" sx={{ marginBottom: "1.5rem" }}>
                <Grid container spacing={3}>
                  <Grid item xs={3}>
                    <SelectFields
                      field={{
                        name: "",
                        label: "",
                        value: selectedReplNO,
                        errors: {},
                      }}
                      options={replnos}
                      onChange={(e, v) => setSelectedReplNO(v)}
                    />
                  </Grid>
                  
                  <Grid item xs={1.5}>
                    <MDButton color="info" variant="gradient" onClick={handleDownload} 
                      disabled={selectedReplNO === null || selectedReplNO.trim() === "" }>
                      Download
                    </MDButton>
                  </Grid>
                </Grid>
              </Fieldset>
      <MDBox my={3}>
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus}/>
{/* 
        {<LoadingDialog />} */}

        <MDBox>{render()}</MDBox>
      </MDBox>
    {/* </ListLayout> */}
            </InboundHeaderCard>
        </InboundLayout>
    )
}

export default UpdateReplenishment;

function Consolidate({ replnos, customerCode, zoneID, onError, editPermission }) {
  const [list, setList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const [alert, setAlert] = useState(null);
  const [reasoncodes, setReasonCodes] = useState([]);
  const [selectedReasonCode, setSelectedReasonCode] = useState("");
  const [isConsolidating, setIsConsolidating] = useState(false);
  const [isForceClosing, setIsForceClosing] = useState(false);
  const { isFetching, refetch } = useQuery({
    queryKey: ["phyopnbalscan-details"],
    queryFn: () => retrieveReplenishmentList(replnos),
    enabled: !!replnos,
    onSuccess: (data) => setList(data.data.data),
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const consolidateMutation = useMutation(replconsolidate, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);  
      //refetchPNo;
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const updateMutation = useMutation(updaterepllist, {
    onSuccess: (data) => {
      // setAlert(<Success data={data} onChange={setAlert} />);
      // setSelectedReasonCode(null);  
      //refetchPNo;
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const onconsolidate = () => {
    if (isConsolidating) return; // Prevent multiple triggers while processing
    setIsConsolidating(true);
    console.log(list);
    // Trigger update mutation
    updateMutation.mutate(list ,{
        onSuccess: () => {
          // Clear the list only after the update is successful
          //setList([]);
          
          // Log values for debugging
          console.log({
            replnos, 
            customerCode, 
            selectedReasonCode: selectedReasonCode?.value,
          });
  
          // Trigger consolidation mutation
          consolidateMutation.mutate({
            customer_code:customerCode,
            repl_no:replnos,
            items:list.map(x=>({line_no:x.lineNo,scan_quantity:x.scanQuantity}))
          },{
            onSuccess: () => {
              setList([]);
            },
          //   repl_no: replnos,
          //   customer_code: customerCode,
          //   reason_code: selectedReasonCode?.value,
          // },{
            onSettled: () => {
              setIsConsolidating(false);
            },
          });
        },
        onError: (error) => {
          console.error('Update failed:', error);
          setIsConsolidating(false);
        },
      }
    );
  };

  // const onconsolidate = () => {
  //   updateMutation.mutate({list});
  //   setList([]);
  //   console.log({ replnos, customerCode,selectedReasonCode:selectedReasonCode.value })
  //   consolidateMutation.mutate({ repl_no:replnos, customer_code:customerCode,reason_code:selectedReasonCode.value });
  // };

  useEffect(() => {
    if (replnos) {
      refetch(); // Refetch data whenever pnos changes
    }
  }, [replnos, refetch]);

  const forcecloseMutation = useMutation(replforceclose, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);
      getReplenishmentNoList(customerCode);
      //refetchPNo;
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const onforceclose = () => {
    setList([]);
    console.log({ replnos, customerCode })
    forcecloseMutation.mutate({ replnos, customerCode });
  };

  const { refetch:refetchReasonCode } = useQuery({
    queryKey: [ "ReasonCodeOption"],
    queryFn: () =>
      getadjustmentreasoncode(),
    enabled: false,
    onSuccess: (data) => {
      console.log(data);
      //setReasonCodes(data.data.data);
      setReasonCodes(data.data.data.map(item => ({
        label: item.description1, // Adjust this to the column you want to display
        value: item.id, // Or any other identifier you need
      })));
    },
    onError: (error) => onError(error, setAlert),
  });

  const latestCountListcolumns2 = [

    {
      header: "SKU Code",
      accessorKey: "skuCode",
    },
    
    {
      header: "From Warehouse",
      accessorKey: "fromWarehouse",
    },
    {
      header: "From Zone",
      accessorKey: "fromZone",
    },
    {
      header: "From Location",
      accessorKey: "fromLocation",
    },
    {
      header: "From Carton",
      accessorKey: "fromCartonID",
    },
    {
      header: "To Warehouse",
      accessorKey: "toWarehouse",
    },
    {
      header: "To Zone",
      accessorKey: "toZone",
    },
    {
      header: "To Location",
      accessorKey: "toLocation",
    },
    {
      header: "To Carton",
      accessorKey: "toCartonID",
    },
    {
      header: "Replenish Qty",
      accessorKey: "quantity",
      ...({ cell: EditableNumber }),
    },
  ];

  useEffect(() => {
    refetchReasonCode(); // Fetch reason codes when the component mounts
  }, [refetchReasonCode]);
  return (
    <>
      {isFetching && <LoadingDialog />}
      {alert}
      <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mt: "0.2rem" ,mb: "0.2rem"}}>
      <Grid item  xs={12} >
      <CheckboxTable2 data={list} columns={latestCountListcolumns2} setData={setList} />
                   {/*  <SelectFields
                      field={{
                        name: "",
                        label: "Reason Code",
                        value: selectedReasonCode,
                        errors: {},
                      }}
                      options={reasoncodes}
                      onChange={(e, v) => {
                        console.log("Selected Reason Code:", v); // Log the selected reason code
                        setSelectedReasonCode(v);
                      }}
                    />*/}
                  </Grid> 
                  </Grid>
                    <MDButton color="info" variant="gradient" onClick={onconsolidate}
                    //disabled={(!selectedReasonCode || selectedReasonCode.value === null || selectedReasonCode.value.trim() === "" || replnos === null || replnos.trim() === "") && !editPermission}
                     disabled={replnos === null || replnos.trim() === ""}
                     style={{ marginRight: '1rem' }}
                     >
                      Consolidate
                    </MDButton>
                    <MDButton color="info" variant="gradient" onClick={onforceclose}
                     disabled={(replnos === null || replnos.trim() === "")}
                     >
                      Force Close
                    </MDButton>
    </>
  );
}
